import * as variables from './variables.js';

import * as $ from 'jquery';
// NOTE: Colorbox must see jQuery on the window in order to work properly
declare global {
	interface Window { jQuery: JQueryStatic; }
}
window.jQuery = $;

import './lib/AnimationEasing';

// import {Analytics} from '@plaudit/analytics';
// Analytics.getInstance();

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);


import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.menu-item-has-children > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

/* CSS - Object Fit polyfill */
// @ts-ignore
var objectFitImages = require('object-fit-images');
if (!objectFitImages.supportsObjectFit) {
	var someImages = document.querySelectorAll('.responsiveImage img');
	for (var i = 0, l = someImages.length; i < l; i++) {
		// let style = window.getComputedStyle(someImages[i]);
		let position = someImages[i].getAttribute('data-position') || 'center';
		let fit = someImages[i].getAttribute('data-fit') || 'cover';
		let style = someImages[i].getAttribute('style') || '';

		someImages[i].setAttribute('style', style + 'font-family: "object-fit: ' + fit + ';object-position: ' + position + ';"');
	}
	objectFitImages(someImages);
}


/* Basic Carousels */
import Carousel from './component/Carousel';
const carouselElem = document.querySelector('body.home .carousel');
if (carouselElem) {
	new Carousel({
		analyticsCategory: 'Carousel',
		carouselEl: carouselElem as HTMLElement,
		duration: 7500,
		allowIndicatorClick: true,
		autoHeight: true,
		autoAdvance: true
	});
	// TODO: [CROST] autoAdvance is buggy, last slide to first transition changes from next to prev.
}


// AJAX Forms - Used on calcaultor pages
if ($('.ajaxForm').length > 0) {
	$('body').on('submit', '.ajaxForm', (e) => {
		const $form = $(e.target);
		const rerender = $form.attr('data-ajaxrerender');
		if (rerender != null) {
			e.preventDefault();

			const formData = $form.serialize();
			const action = $form.attr('action') ?? window.location.href.split('?')[0];

			$(rerender).load(action + " " + rerender, formData);
		}
	});
}

import lightbox from './component/Lightbox';
lightbox();